import { render } from "./Recipes-add.vue?vue&type=template&id=6d416c14&scoped=true"
import script from "./Recipes-add.vue?vue&type=script&lang=js"
export * from "./Recipes-add.vue?vue&type=script&lang=js"

import "./Recipes-add.vue?vue&type=style&index=0&id=6d416c14&scoped=true&lang=css"
import "./Recipes-add.vue?vue&type=style&index=1&id=6d416c14&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d416c14"]])

export default __exports__